var _circle, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTickGreyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99805,
    cy: 9,
    r: 9,
    fill: "#ACB5BD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.348 6.85L8.84805 12.35C8.74805 12.45 8.64805 12.5 8.49805 12.5C8.34805 12.5 8.24805 12.45 8.14805 12.35L5.64805 9.85C5.44805 9.65 5.44805 9.35 5.64805 9.15C5.84805 8.95 6.14805 8.95 6.34805 9.15L8.49805 11.3L13.648 6.15C13.848 5.95 14.148 5.95 14.348 6.15C14.548 6.35 14.548 6.65 14.348 6.85Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10660_72818",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 6,
    width: 10,
    height: 7
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.348 6.85L8.84805 12.35C8.74805 12.45 8.64805 12.5 8.49805 12.5C8.34805 12.5 8.24805 12.45 8.14805 12.35L5.64805 9.85C5.44805 9.65 5.44805 9.35 5.64805 9.15C5.84805 8.95 6.14805 8.95 6.34805 9.15L8.49805 11.3L13.648 6.15C13.848 5.95 14.148 5.95 14.348 6.15C14.548 6.35 14.548 6.65 14.348 6.85Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10660_72818)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99805 3H15.998V15H3.99805V3Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGreyIcon);
export default __webpack_public_path__ + "static/media/TickGreyIcon.b2b544efc3a890d1d8d954cb3eb4453a.svg";
export { ForwardRef as ReactComponent };